// extracted by mini-css-extract-plugin
export default {"container":"contact_container__5RIKE","container__form":"contact_container__form__xJQQC"};